const parser = new DOMParser();

export function parseFromString(item) {
  return parser.parseFromString(item, 'text/html').body.firstChild || null;
}
